import React from "react";
import { Link } from "react-router-dom";
import { Building, Users, Globe, Award, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ff018244-580d-47eb-b754-fa20aec11c8d/artifacts/2zc3j2vv_jini%20studio%20logo%20.png";

function AboutPage() {
  return React.createElement("div", { className: "min-h-screen bg-white" },
    // Nav
    React.createElement("nav", { className: "bg-white border-b border-neutral-100 px-6 py-4" },
      React.createElement("div", { className: "max-w-5xl mx-auto flex items-center justify-between" },
        React.createElement(Link, { to: "/", className: "flex items-center gap-2" },
          React.createElement("img", { 
            src: LOGO_URL, 
            alt: "Jini Studio", 
            className: "h-16 w-auto"
          })
        ),
        React.createElement(Link, { to: "/" },
          React.createElement(Button, { variant: "ghost" }, React.createElement(ArrowLeft, { className: "w-4 h-4 mr-2" }), "Back to Home")
        )
      )
    ),
    
    // Content
    React.createElement("main", { className: "max-w-4xl mx-auto px-6 py-16" },
      React.createElement("h1", { className: "font-display text-4xl font-bold text-neutral-900 mb-8" }, "About Us"),
      
      React.createElement("div", { className: "prose prose-lg max-w-none" },
        React.createElement("p", { className: "text-xl text-neutral-600 mb-8 leading-relaxed" },
          "Jini Studio is an AI innovation by Zaroori Retail, India's leading premium marketplace management company. We're transforming how e-commerce brands create product imagery through cutting-edge artificial intelligence."
        ),
        
        React.createElement("div", { className: "grid md:grid-cols-2 gap-8 my-12" },
          React.createElement("div", { className: "bg-indigo-50 rounded-2xl p-6" },
            React.createElement(Building, { className: "w-10 h-10 text-indigo-600 mb-4" }),
            React.createElement("h3", { className: "font-display text-xl font-semibold text-neutral-900 mb-2" }, "4,200+ Clients"),
            React.createElement("p", { className: "text-neutral-600" }, "Trusted by thousands of e-commerce brands across India and internationally")
          ),
          React.createElement("div", { className: "bg-violet-50 rounded-2xl p-6" },
            React.createElement(Globe, { className: "w-10 h-10 text-violet-600 mb-4" }),
            React.createElement("h3", { className: "font-display text-xl font-semibold text-neutral-900 mb-2" }, "Global Presence"),
            React.createElement("p", { className: "text-neutral-600" }, "Offices in India with international operations across multiple countries")
          ),
          React.createElement("div", { className: "bg-emerald-50 rounded-2xl p-6" },
            React.createElement(Users, { className: "w-10 h-10 text-emerald-600 mb-4" }),
            React.createElement("h3", { className: "font-display text-xl font-semibold text-neutral-900 mb-2" }, "Expert Team"),
            React.createElement("p", { className: "text-neutral-600" }, "Dedicated professionals in AI, photography, and e-commerce")
          ),
          React.createElement("div", { className: "bg-amber-50 rounded-2xl p-6" },
            React.createElement(Award, { className: "w-10 h-10 text-amber-600 mb-4" }),
            React.createElement("h3", { className: "font-display text-xl font-semibold text-neutral-900 mb-2" }, "Industry Leader"),
            React.createElement("p", { className: "text-neutral-600" }, "Recognized for excellence in premium marketplace management")
          )
        ),
        
        React.createElement("h2", { className: "font-display text-2xl font-bold text-neutral-900 mt-12 mb-4" }, "Our Mission"),
        React.createElement("p", { className: "text-neutral-600 mb-6" },
          "We believe every brand deserves access to professional product photography. Our AI-powered platform democratizes high-quality imagery, enabling businesses of all sizes to compete with enterprise-level visuals at a fraction of the cost."
        ),
        
        React.createElement("h2", { className: "font-display text-2xl font-bold text-neutral-900 mt-12 mb-4" }, "Zaroori Retail"),
        React.createElement("p", { className: "text-neutral-600 mb-6" },
          "Zaroori Retail is a premium marketplace management company specializing in e-commerce solutions. With expertise across fashion, jewellery, cosmetics, and lifestyle products, we've helped over 4,200 brands succeed on major marketplaces. Jini Studio represents our commitment to innovation and making professional tools accessible to all."
        )
      )
    ),
    
    // Footer
    React.createElement("footer", { className: "bg-neutral-100 py-8 px-6" },
      React.createElement("div", { className: "max-w-5xl mx-auto text-center text-neutral-500 text-sm" },
        "© 2025 Jini Studio by Zaroori Retail. All rights reserved."
      )
    )
  );
}

export default AboutPage;
